import { defineStore } from 'pinia';
import { ref } from "vue";
export const useStringeeStore = defineStore('stringee', {
    state: () => ({
        client: null,
        call: null,
    }),
    actions: {
       
    },
    getters: {
        
    }
});